import axios from '../axios';

export const all = (params = {}) => {
  return axios.get('/navigation', { params });
};

export const allProductElements = (params = {}) => {
  return axios.get('/products-navigation', { params });
};

export const updateOrCreate = (payload) => {
  return axios.post('/navigation', payload);
};

export const updateOrCreateProducts = (payload) => {
  return axios.post('/products-navigation', payload);
};

export const show = (id, params = {}) => {
  return axios.get(`/navigation/${id}`, { params });
};

export const showProduct = (id, params = {}) => {
  return axios.get(`/products-navigation/${id}`, { params });
};

export const destroy = (id) => {
  return axios.delete(`/navigation/${id}`);
};

export const destroyProduct = (id) => {
  return axios.delete(`/products-navigation/${id}`);
};

export const updateDescription = (payload) => {
  return axios.post('/navigation/update-description', payload);
};

export const updateDescriptionProduct = (payload) => {
  return axios.post('/products-navigation/update-description', payload);
};

export const aiTranslateNavigation = (navigationGroupId, fromLocale, toLocale) => {
  return axios.post(`/navigation/ai-translate`, {
    navigation_group_id: navigationGroupId,
    from_locale: fromLocale,
    to_locale: toLocale,
  });
};

export const aiTranslateProductNavigation = (productNavigationGroupId, fromLocale, toLocale) => {
  return axios.post(`/products-navigation/ai-translate`, {
    product_navigation_group_id: productNavigationGroupId,
    from_locale: fromLocale,
    to_locale: toLocale,
  });
};

export const updateProductNavigationOrder = (orderData) => {
  return axios.post(`/products-navigation/update-order`, {
    order: orderData,
  });
};

export const getFilterFields = () => {
  return axios.get(`/products-navigation/filter-fields`);
};